import { DateInputField } from "@hatch-digital-nl/abs-storybook/legacy";
import { ChangeEvent, InvalidEvent, JSX, useState } from "react";
import { format } from "date-fns";
import { getValidityPeriodDisplay } from "../../../../common/utils/getValidityPeriodDisplay";
import { useAssociatedFieldId } from "../../../../common/utils/useAssociatedFieldId";

interface Props {
    id: number;
    value: string;
    onChange: (event: ChangeEvent<HTMLInputElement>, id: number) => void;
    expiresAt?: string;
    className?: string;
    label?: string;
}

export const DateInputFieldComponent = (props: Props): JSX.Element => {
    const {
        id,
        value,
        onChange,
        expiresAt,
        className = "c-edit-certificate-modal__form-group",
        label = "Datum behaald",
    } = props;

    const [dateError, setDateError] = useState<string>();
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={className}>
            <label htmlFor={fieldId}>{label}</label>
            <div ref={fieldRef}>
                <DateInputField
                    required={true}
                    value={value || ""}
                    max={format(new Date(), "yyyy-MM-dd")}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        setDateError(undefined);
                        onChange(event, id);
                    }}
                    onInvalid={(event: InvalidEvent<HTMLInputElement>) => {
                        event.preventDefault();

                        if (
                            (event.target as HTMLInputElement).validity
                                .valueMissing
                        ) {
                            setDateError("Datum behaald is verplicht");
                        }
                    }}
                />
            </div>
            {dateError && <p className={"c-error-message"}>{dateError}</p>}
            {value && expiresAt && (
                <p
                    className={
                        "c-edit-certificate-modal__form-group__expiry-date"
                    }
                >
                    {
                        getValidityPeriodDisplay({
                            expiresAt,
                            isAlreadyFormatted: true,
                        }).text
                    }
                </p>
            )}
        </div>
    );
};
